import {
  Card,
  Text,
  Button,
  ThemeIcon,
  Flex,
  Modal,
  Stack,
  Group,
} from "@mantine/core";
import { SiZoom } from "react-icons/si";
import { useState } from "react";
import { zoomOAuth } from "api";
import { useUser } from "stores/useUser";
import { useDisclosure } from "@mantine/hooks";
import { doc, setDoc } from "firebase/firestore";
import { FirestoreDB } from "utils/firebase";
import { notify } from "utils/common";

const ZoomCard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModalOpened, { open, close }] = useDisclosure(false);
  const { user, setUser } = useUser();
  const isConnected = Boolean(user?.zoomConnection && user?.zoomConnection?.state === "connected");

  const handleConnect = async () => {
    setIsLoading(true);
    // Redirect to Zoom OAuth URL
    const { url } = await zoomOAuth();
    window.location.href = url;
  };

  const handleDisconnect = async () => {
    try {
      setIsLoading(true);
      await setDoc(
        doc(FirestoreDB, "users", user?.uid),
        { zoomConnection: null },
        { merge: true },
      );
      setIsLoading(false);
      setUser({
        ...user,
        zoomConnection: null,
      });
      console.log("Disconnect Zoom");
      notify("Zoom disconnected", "success");
      close();
    } catch (e) {
      console.error("Error disconnecting Zoom:", e);
      notify("Failed to disconnect Zoom. Please try again.", "error");
      setIsLoading(false);
    }
  };

  const handleButtonClick = async () => {
    if (isConnected) {
      open();
    } else {
      await handleConnect();
    }
  };

  return (
    <>
      <Card withBorder shadow="sm" radius="md" padding="lg">
        <Flex justify="space-between" align="center" gap="md">
          <Flex gap="md" align="center">
            <ThemeIcon
              size={48}
              radius="md"
              variant="light"
              style={{
                backgroundColor: "#2D8CFF15",
                color: "#2D8CFF",
                minWidth: "48px",
              }}
            >
              <SiZoom size={24} />
            </ThemeIcon>

            <div>
              <Text
                fw={600}
                size="lg"
                style={{ lineHeight: 1, marginBottom: 4 }}
              >
                Zoom
              </Text>
              <Text size="sm" color="dimmed" style={{ lineHeight: 1.4 }}>
                Automatically launches Gaintime bots in your Zoom meetings for
                enhanced productivity.
              </Text>
            </div>
          </Flex>

          <Button
            variant={isConnected ? "outline" : "filled"}
            color={isConnected ? "red" : "blue"}
            onClick={handleButtonClick}
            radius="md"
            size="sm"
            style={{ minWidth: "120px" }}
            loading={isLoading}
          >
            {isConnected ? "Disconnect" : "Connect"}
          </Button>
        </Flex>
      </Card>

      <Modal
        opened={confirmModalOpened}
        onClose={close}
        title="Disconnect Zoom"
        centered
      >
        <Stack>
          <Text size="sm">
            Are you sure you want to disconnect your Zoom? You will need to
            reconnect to use Gaintime bots in your meetings again.
          </Text>
          <Group position="right" mt="md">
            <Button variant="default" onClick={close} disabled={isLoading}>
              Cancel
            </Button>
            <Button color="red" onClick={handleDisconnect} loading={isLoading}>
              Disconnect
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default ZoomCard;
